import { FC, ReactNode } from 'react';
import { Button } from 'shared/components/ui/Button';
import './index.scss';
import { Icons } from '../ui/Icons';
import { Popup } from '../Popup';

type TErrorWrapper = {
  message?: string;
  backTo?: string;
  backToText?: string;
  children?: ReactNode;
};

export const ErrorWrapper: FC<TErrorWrapper> = ({
  message,
  backTo,
  backToText,
  children,
}) => {
  if (!!message && !!children) return null;

  return (
    <div className="error-wrapper">
      <Popup open={true} positionVertical="center" title="Ошибка">
        <div className="popup__content">
          {message && <p>{message}</p>}
          {children && <p>{children}</p>}
        </div>
        {backTo && (
          <Button className="error-wrapper__button" link={backTo}>
            <Icons name="icon_arrow-right" />
            {backToText}
          </Button>
        )}
      </Popup>
    </div>
  );
};
